module.exports = __webpack_public_path__ + "img/filter-intensity-high--active.67ab052f.svg";